import {useOnboardingInternalState} from '#/screens/Onboarding/state'
import {StepAudience} from '#/screens/Onboarding/StepGoal/StepAudience'
import {StepChildTopics} from '#/screens/Onboarding/StepGoal/StepChildTopics'
import {StepCreatorRole} from '#/screens/Onboarding/StepGoal/StepCreatorRole'
import {StepFamilyStages} from '#/screens/Onboarding/StepGoal/StepFamilyStages'
import {StepGoalSelection} from '#/screens/Onboarding/StepGoal/StepGoalSelection'
import {StepLearnerStage} from '#/screens/Onboarding/StepGoal/StepLearnerStage'
import {StepOrgType} from '#/screens/Onboarding/StepGoal/StepOrgType'
import {StepParentTopics} from '#/screens/Onboarding/StepGoal/StepParentTopics'
import {StepTopics} from '#/screens/Onboarding/StepGoal/StepTopics'

export function StepGoal() {
  const {state} = useOnboardingInternalState()
  switch (state.activeStep) {
    case 'goal':
      return <StepGoalSelection />
    case 'goal-learner-stage':
      return <StepLearnerStage />
    case 'goal-parent-stages':
      return <StepFamilyStages />
    case 'goal-parent-topics':
      return <StepParentTopics />
    case 'goal-parent-child-topics':
      return <StepChildTopics />
    case 'goal-creator-role':
      return <StepCreatorRole />
    case 'goal-org-type':
      return <StepOrgType />
    case 'goal-audience':
      return <StepAudience />
    case 'goal-topics':
      return <StepTopics />
    default:
      return null
  }
}
